// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ease-custom{transition-timing-function:cubic-bezier(.61,-.53,.43,1.43)}", ""]);
// Exports
module.exports = exports;
